import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable mouse-wheel changing values on focused number inputs.
// (Firefox/Chrome scroll-jacking the value is unintuitive and causes
//  accidental decimals in our admin forms.)
document.addEventListener(
  "wheel",
  (e) => {
    const t = e.target;
    if (t && t.tagName === "INPUT" && t.type === "number" && document.activeElement === t) {
      t.blur();
    }
  },
  { passive: true },
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
